import React from 'react';
import { ContentfulImage } from '@jbhi-fi/components/src/ContentfulImage/ContentfulImage';
import { ContentfulFeaturedBanner } from '@jbhi-fi/apis/src/contentful/types';
import { AssetTransformer } from '@jbhi-fi/components/src/Contentful/transformers/AssetTransformer';
import { CardTransformer } from '@jbhi-fi/components/src/Contentful/transformers/CardTransformer';
import { CardGridCardProps } from '@jbhi-fi/components/src/Card/CardGrid/CardGrid';
import { breakpointSizePx } from '@jbhi-fi/lanyard-ui/themes';

export class FeaturedBannerTransformer {
  static toCardProps = ({ fields }: ContentfulFeaturedBanner): CardGridCardProps => {
    if (!fields?.bannerImage?.fields) return CardTransformer.LOADING_CARD_PROPS;

    return {
      cover: (
        <ContentfulImage
          {...AssetTransformer.toContentfulImageProps(fields.bannerImage)}
          sizes={`(max-width: ${breakpointSizePx.md}px) 100vw, 350px`}
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
      ),
      href: fields?.url,
      target: fields?.shouldOpenInNewWindow ? '_blank' : undefined,
      isContained: false,
    };
  };
}
